import axios from 'axios';
import store from './store';
import { normalizeForBackend } from '@/utils/normalizeData';

// Для локальной разработки используем прокси, чтобы обойти проблемы с SSL
// Прокси настроен в vue.config.js с secure: false
const apiUrl = process.env.VUE_APP_API_URL;
const isDevelopment = process.env.NODE_ENV === 'development';

// В режиме разработки всегда используем прокси для обхода SSL проблем
// В продакшене используем переменную окружения
if (isDevelopment) {
  axios.defaults.baseURL = '/api';
} else {
  axios.defaults.baseURL = apiUrl || '/api';
}


axios.interceptors.request.use(async function (config) {
    config.headers = {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    };

    // Нормализуем данные для отправки на бэкенд (конвертируем camelCase в snake_case)
    // Исключаем FormData и другие специальные типы
    if (config.data && typeof config.data === 'object' && !(config.data instanceof FormData)) {
        config.data = normalizeForBackend(config.data);
    }

    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const originalConfig = error.config;

    if (error.response && error.response.status == 401) {
        console.log('1)обнаружена ошибка запроса');
        if (!store.getters.pendingUpdate_RefreshTokens) {
            store.dispatch('refresh');
        }

        await store.getters.pendingUpdate_RefreshTokens;
        console.log('повторный запрос', originalConfig);
        return axios(originalConfig);
    }

    return Promise.reject(error);
});



export default axios;
